export const ru = {
    'icon-title': 'Рекомендации',
    'popup-hint': 'Советы, которые помогут повысить эффективность кампании',
    'popup-title': 'Рекомендации'
};
